document.addEventListener('variant:change', function (event) {
  if (!event.detail || !event.detail.variant) return;

  const selectedVariantId = event.detail.variant.id;

  // Hide all treatment price blocks
  document.querySelectorAll('.option--value-treatment').forEach((el) => {
  //el.classList.add('hidden');
  });

  // Show the selected variant block
  const activeEl = document.getElementById('optionTreatmentValue_' + selectedVariantId);
  if (activeEl) {
   // activeEl.classList.remove('hidden');
  }
});

document.addEventListener("click", function (e) {
  const form = e.target.closest('form[is="product-form"]');

  if (form) {
    e.stopPropagation();
  }
}, true);